import React, { useState,useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";

// Stylesheet
import "./Header.css";

// Material UI Icons
import CloseIcon from "@mui/icons-material/Close";
import MenuIcon from "@mui/icons-material/Menu";

// Assets
import logo from "../../assets/logo.png";
import searchHamburger from "../../assets/Search.png";

// Wallet
import WalletPopup from "./wallet/WalletPopup";
import { connect, useDispatch, useSelector } from "react-redux";
import { Toaster } from "react-hot-toast";
import { authFeatureKey, nftFeatureKey } from "../../store/featureKeys";
import * as authActions from "../../store/actions/authActions";
import * as nftActions from "../../store/actions/nftActions";


function Header({ state }) {
  let dispatch = useDispatch();
  let history = useHistory();
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });
  const { openConnectModal, isConnected } = useSelector((state) => {
    return state[authFeatureKey];
  });
  const [navbarOpen, setNavbarOpen] = useState(false);
  const handleToggle = () => {
    setNavbarOpen((prev) => !prev);
  };
  const closeMenu = () => {
    setNavbarOpen(false);
  };

  const [searchOpen, setSearchOpen] = useState(0);

  let [searchQuery, setSearchQuery] = useState("");


  const handleSearchQuery = (event) => {
    if (event.key === "Enter" && searchQuery !== "") {
      console.log("enter press here! ", searchQuery);
      dispatch(nftActions.searchInNFTCollection(searchQuery));
      history.push(`/explore?name=${searchQuery}`);
    }
  };

  return (
    <header className="header ">
      <Toaster position="top-right" reverseOrder={false} />
      {!isTabletOrMobile ? (
        <div className="laptop-header">
          <Link to="/" onClick={() => closeMenu()} class='logo-parent'>
            <img src={logo} alt="logo" className="header-logo logo-child" />
            <div class='logo-child'>
              <h2 class='logo-text'>LoopGem</h2>
              <h2 class='logo-subtext'>BETA</h2>
            </div>
          </Link>
          <input
            // onSubmit={handleSubmit}
            className="search"
            type="search"
            placeholder="search"
            id={"searchBox"}
            onKeyPress={handleSearchQuery}
            onChange={(e) => {
              setSearchQuery(e.target.value);
            }}
          />
          <div className="nav">
            <Link to="/" onClick={() => closeMenu()}>
              <h2>Home</h2>
            </Link>
            <Link to="/explore" onClick={() => closeMenu()}>
              <h2>Explore</h2>
            </Link>
            {isConnected ? (
              <Link to="/favourites" onClick={() => closeMenu()}>
                <h2>Favorites</h2>
              </Link>
            ) : (
              <div
                onClick={() => {
                  closeMenu();
                  dispatch(authActions.openConnectModal());
                }}
              >
                <h2>Favorites</h2>
              </div>
            )}
          </div>
          {isConnected ? (
            <Link to="/createnft" onClick={() => closeMenu()}>
              <button className="create-button">Create</button>
            </Link>
          ) : (
            <div
              onClick={() => {
                closeMenu();
                dispatch(authActions.openConnectModal());
              }}
            >
              <button className="create-button">Create</button>
            </div>
          )}
          <div className="nav-icons">
            <WalletPopup />
          </div>
        </div>
      ) : (
        <div className="hamburger">
          <div className={`hamburger-nav ${navbarOpen ? "show-nav" : ""}`}>
            <Link to="/" onClick={() => closeMenu()}>
              <h2>Home</h2>
            </Link>
            <Link to="/explore" onClick={() => closeMenu()}>
              <h2>Explore</h2>
            </Link>
            {isConnected ? (
                <Link to="/favourites" onClick={() => closeMenu()}>
                  <h2>Favorites</h2>
                </Link>
            ) : (
                <div
                    onClick={() => {
                      closeMenu();
                      dispatch(authActions.openConnectModal());
                    }}
                >
                  <h2>Favorites</h2>
                </div>
            )}
            {isConnected ? (
                <Link to="/createnft" onClick={() => closeMenu()}>
                  <button className="create-button">Create</button>
                </Link>
            ) : (
                <div
                    onClick={() => {
                      closeMenu();
                      dispatch(authActions.openConnectModal());
                    }}
                >
                  <button className="create-button">Create</button>
                </div>
            )}
          </div>
          <div className="hamburger-header">
            <button onClick={handleToggle} className="hamburger-button">
              {navbarOpen ? (
                <CloseIcon className="hamburger-buttons" />
              ) : (
                <MenuIcon className="hamburger-buttons" />
              )}
            </button>
            <Link to="/" onClick={() => closeMenu()} class='logo-parent'>
              <img src={logo} alt="logo" className="header-logo logo-child" />
            </Link>
            <div className="nav-icons ">
              <button
                className="hamburger-search"
                onClick={() => setSearchOpen(1)}
              >
                {searchOpen !== 1 ? (
                  <img src={searchHamburger} alt="" className="header-icon" />
                ) : (
                    <div>
                      <form className="wrapper-search" action="">
                        <input
                            // onSubmit={handleSubmit}
                            className="search"
                            type="search"
                            placeholder="search"
                            id={"searchBox"}
                            onKeyPress={handleSearchQuery}
                            onChange={(e) => {
                              setSearchQuery(e.target.value);
                            }}
                        />
                      </form>
                    </div>
                )}
              </button>

              <WalletPopup />
            </div>
          </div>
        </div>
      )}
    </header>
  );
}

const mapStateToProps = (state) => ({ state: state.currentUser });
export default connect(mapStateToProps)(Header);